



import StoreHistoryChatPdfComponent from "@/components/admin/storeHistory/storeHistoryChatPdfComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "StoreHistoryChatPdfPage",
  components: {
    StoreHistoryChatPdfComponent,
  },
})
export default class StoreHistoryChatPdfPage extends Vue {}
